import { StringParam, useQueryParam } from 'use-query-params'

export const useMenuItemQueryParam = () =>
  useQueryParam('menuItem', StringParam)
